import { h, reactive, Transition } from 'vue'
import './style.scss'

const state = reactive({
    name: '',
    show: false,
})

const useAProgressBar = (props, ctx) => {

    const show = (name) => {
        state.name = typeof name !== 'undefined' ? name : 'default'
        state.show = true
    }

    const hide = () => {
        state.show = false
        state.name = ''
    }

    return {
        show,
        hide,
    }
}

const AProgressBar = {
    name: 'AProgressBar',
    props: {
        state: {
            type: Object,
        },
        name: {
            type: String,
            default: 'default'
        },
        show: {
            type: Boolean,
            default: false,
        }
    },
    setup: (props, ctx) => {

        const renderView = () =>
            h(Transition, {
                props: {
                    name: 'fade',
                },
                name: 'fade',
            }, state.show && props.name === state.name ? () => h('div', {
                    ...ctx.attrs,
                    class: ['progress-bar-layout', 'progress-bar', 'loading', ctx.attrs.class],
                },
                [
                    h('div', {
                        class: ['progress-bar-indicator']
                    }),
                    h('div', {
                        class: ['progress-bar-backdrop'],
                    })
                ]
            ): void 0)

        return {
            renderView,
        }
    },
    render() {
        return this.renderView()
    },
}

export { AProgressBar, useAProgressBar }
